import Vue from 'vue'
import App from './App.vue'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import store from './store'
import globalUtils from './utils/global'
import globalConfig from './config/globalConfig'
import i18n from './i18n'

Vue.config.productionTip = false
Vue.prototype.$utils = globalUtils
Vue.prototype.$config = globalConfig

Vue.use(ViewUI);

Vue.directive('debounce', {
    inserted(el, binding) {
        let timer = {}
        el.addEventListener('click', () => {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                binding.value()
            }, 500)
        })
    }
})

new Vue({
    i18n,
    store,
    render: h => h(App),
}).$mount('#app')